import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import logo1 from "../assets/logo.png";
import logo2 from "../assets/logo2.png";
import { Link } from "react-router-dom";
import NavMenu from "./NavMenu";
import { callRedirectionNo, WhatsappRedirection } from "../api/Redirection";
import { Button } from "@mui/material";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollDirection, setScrollDirection] = useState("up");

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Determine scroll direction
      if (currentScrollY > lastScrollY) {
        setScrollDirection("down");
      } else {
        setScrollDirection("up");
      }

      // Check if scrolled at all
      setIsScrolled(currentScrollY > 0);
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMenuToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleWhatsAppClick = () => {
    window.open(WhatsappRedirection, "_blank");
  };

  return (
    <Box sx={styles.navContainer}>
      <AppBar
        sx={{
          ...styles.appBar,
          backgroundColor: isScrolled ? "#FBF7F3" : "transparent",
          transform:
            scrollDirection === "down" ? "translateY(-100%)" : "translateY(0)",
          transition:
            "transform 0.3s ease-in-out, background-color 0.3s ease-in-out",
        }}
      >
        <Toolbar sx={styles.toolbar}>
          {/* Logo */}
          <Link to={"/"}>
            <Box
              component="img"
              src={isScrolled ? logo2 : logo1}
              alt="Logo"
              sx={styles.logo}
            />
          </Link>
          {/* Navigation Items */}
          <Box sx={styles.navItems}>
            <Typography
              component={Button}
              onClick={() => window.open(callRedirectionNo)}
              sx={{
                ...styles.navText,
                color: isScrolled ? "#4C4C4C" : "#FFFFFF",
                display: { xs: "none", sm: "block" },
              }}
            >
              CALL
            </Typography>
            <Typography
              onClick={handleWhatsAppClick}
              sx={{
                ...styles.navText,
                color: isScrolled ? "#4C4C4C" : "#FFFFFF",
              }}
            >
              BOOK
            </Typography>
            <Typography
              onClick={handleMenuToggle} // Opens the modal
              sx={{
                ...styles.navText,
                color: isScrolled ? "#4C4C4C" : "#FFFFFF",
                cursor: "pointer",
              }}
            >
              MENU
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Full-Width Modal */}
      <Dialog
        fullScreen
        open={isMenuOpen}
        onClose={handleMenuToggle}
        sx={styles.dialog}
      >
        <NavMenu onClose={handleMenuToggle} />
      </Dialog>
    </Box>
  );
};

const styles = {
  appBar: {
    boxShadow: "none",
    padding: { xs: "10px 10px", sm: "10px 50px" },
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1000,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  navContainer: {
    display: "flex",
    flexDirection: "column",
  },
  navItems: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    gap: "60px",
    // marginRight: "50px",
  },
  navText: {
    fontFamily: "'ZapfHumnst BT', sans-serif",
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "36px",
    letterSpacing: "0.05em",

    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  logo: {
    height: "81px",
    cursor: "pointer",
  },
  dialog: {
    "& .MuiDialog-paper": {
      backgroundColor: "#f9eee2",
      width: "100%",
      overflow: "hidden",
      height: "100%",
    },
  },
};

export default Navbar;
